/**
 * Resolves the base API URL for Create React App.
 * Prioritizes REACT_APP_NEXT_LEGACY_API_URL if configured.
 * Strictly falls back to REACT_APP_BASE_API_URL (preserving 100% backward compatibility
 * on staging, preprod, and during emergency git-revert rollbacks).
 * Strips any trailing slashes to prevent double slashes in endpoint paths.
 */
export const resolveBaseApiUrl = (env = process.env) => {
  const rawUrl =
    (env && env.REACT_APP_NEXT_LEGACY_API_URL) ||
    (env && env.REACT_APP_BASE_API_URL) ||
    "";
  return rawUrl.replace(/\/+$/, "");
};

export const BASE_API_URL = resolveBaseApiUrl();

export default BASE_API_URL;
